import { useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { Button, Modal, ModalBody } from "reactstrap";
import { Href, OnePersonCallTitle } from "../../../../Constants/Constants";
import { dynamicImage, Image } from "../../../../Utils";
import { Phone, Video } from "react-feather";

const OnePersonCall = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <Fragment>
      <Button color="primary" className="fonts font_label" onClick={toggle}>{OnePersonCallTitle}</Button>
      <Modal isOpen={modal} fade toggle={toggle} centered>
        <ModalBody className="p-0">
          <div className="conferencecall call-modal bg-size custom-modal-1">
            <Image className="bg-img" src={dynamicImage("avtar/big/audiocall.jpg")} alt="Avatar" style={{ display: "none" }}/>
            <div className="center-con text-center">
              <div className="usersprof">
                <div className="profile bg-size" style={{ backgroundImage: `url(${dynamicImage(`avtar/big/videocall_bg.jpg`)})`, backgroundSize: "cover", backgroundPosition: "center center", display: "block" }}>
                  <Image className="bg-img" src={dynamicImage("avtar/big/videocall_bg.jpg")} alt="Avatar" style={{ display: "none" }}/>
                </div>
              </div>
              <p>Incoming Call</p>
              <h3>Jack p angulo</h3>
              <p>Product Manager</p>
              <ul>
                <li><a className="icon-btn btn-danger button-effect btn-xl is-animating cancelcall" href={Href} onClick={toggle}><Phone /></a></li>
                <li><a className="icon-btn btn-success button-effect btn-xl is-animating" href={Href}><Video /></a></li>
              </ul>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default OnePersonCall;
